/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Minikor: Hauptmenü-Dropdowns schließen nicht mehr sofort, wenn die Maus
  // kurz die Lücke zwischen Menüpunkt und Dropdown verlässt (Schonfrist 300 ms).
  function patchHoverDisclosure() {
    var C = customElements.get('hover-disclosure');
    if (!C || C.prototype.__mkPatched) return !!C;
    var origHide = C.prototype.hideDisclosure;
    var origShow = C.prototype.showDisclosure;
    var DELAY = 300;

    C.prototype.hideDisclosure = function () {
      var self = this;
      var args = arguments;
      clearTimeout(self.__mkTimer);
      // Aufruf ohne Event = mouseleave/focusout/Escape -> verzögert schließen
      if (args.length === 0 && window.matchMedia('(hover: hover)').matches) {
        self.__mkTimer = setTimeout(function () {
          if (!self.matches(':hover') && !self.contains(document.activeElement)) {
            origHide.apply(self, args);
          }
        }, DELAY);
        return;
      }
      return origHide.apply(self, args);
    };

    C.prototype.showDisclosure = function () {
      var self = this;
      clearTimeout(self.__mkTimer);
      // andere offene Dropdowns sofort schließen, damit nie zwei offen sind
      document.querySelectorAll('hover-disclosure.is-visible').forEach(function (el) {
        if (el !== self && !el.contains(self) && !self.contains(el)) {
          clearTimeout(el.__mkTimer);
          origHide.call(el);
        }
      });
      return origShow.apply(self, arguments);
    };

    C.prototype.__mkPatched = true;
    return true;
  }

  if (!patchHoverDisclosure() && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('hover-disclosure').then(patchHoverDisclosure);
  }

  // Escape soll trotzdem sofort schließen
  document.addEventListener('keyup', function (evt) {
    if (evt.code !== 'Escape') return;
    document.querySelectorAll('hover-disclosure.is-visible').forEach(function (el) {
      clearTimeout(el.__mkTimer);
      if (el.hideDisclosure) el.hideDisclosure({ type: 'keyup' });
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
